<template>
  <v-tooltip right>
    <template v-slot:activator="{ on, attr }">
      <v-btn
        tile
        icon
        class="flex-grow-1"
        v-on="on"
        v-bind="attr"
        @click="onClick"
        :class="activeClasses"
        ref="button"
      >
        <delete-icon v-if="actionIsDelete" class="icon"></delete-icon>
        <pencil-icon v-if="actionIsModify" class="icon"></pencil-icon>
        <select-icon v-if="actionIsSelect" class="icon"></select-icon> </v-btn
    ></template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import SelectIcon from "vue-material-design-icons/CursorDefaultOutline.vue";

export default {
  props: {
    tooltip: String,
    action: String,
    control: Object
  },
  data() {
    return {
      active: false,
      type: "mutation"
    };
  },
  computed: {
    button() {
      return this.$refs.button;
    },
    activeClasses() {
      if (!this.active) return [];
      return "active";
    },
    actionIsDelete() {
      return this.action === "delete";
    },
    actionIsModify() {
      return this.action === "modify";
    },
    actionIsSelect() {
      return this.action === "select";
    }
  },
  methods: {
    onClick() {
      this.$emit("click", { action: this.action, control: this.control });
    },
    click() {
      this.button.$el.click();
    }
  },
  components: {
    DeleteIcon,
    PencilIcon,
    SelectIcon
  }
};
</script>

<style lang="scss" scoped>
.active {
  background-color: green;

  .icon {
    color: #fff;
  }
}
</style>
